import { DateTime } from "luxon"
import { useCallback, useState } from "react"
import { useDateTime } from "../Localization/useDateTime"
import { useInterval } from "shared/hooks/useInterval"
import { UnreachableCaseError } from "shared/Helpers/lang"

type Options = Readonly<{
    resolution: "minutes" | "days"
}>

function getIntervalForResolution(resolution: Options["resolution"]) {
    switch (resolution) {
        case "minutes":
            return 1000
        case "days":
            return 10 * 1000
        default:
            throw new UnreachableCaseError(resolution)
    }
}

export function useClock({ resolution }: Options) {
    const dateTimeFactory = useDateTime()
    const [clock, setClock] = useState<DateTime>(dateTimeFactory.now())

    const tick = useCallback(() => {
        setClock((prev) => {
            const now = dateTimeFactory.now()
            const isSameToResolution = now.hasSame(prev, resolution)
            return isSameToResolution ? prev : now
        })
    }, [dateTimeFactory])

    useInterval(tick, getIntervalForResolution(resolution))

    return {
        clock
    }
}
